import { useState } from "react";
import { X, Eye, EyeOff } from "lucide-react";
import { useStore, api } from "@/context/StoreContext";

function EyeField({ id, testid, eyeTestid, label, value, onChange, required = true }) {
  const [show, setShow] = useState(false);
  return (
    <div className="field">
      <label>{label}</label>
      <div className="pw-field">
        <input id={id} data-testid={testid} type={show ? "text" : "password"} value={value} onChange={onChange} required={required} minLength={6} />
        <button
          type="button"
          className="pw-eye"
          data-testid={eyeTestid}
          aria-label={show ? "Hide password" : "Show password"}
          onClick={() => setShow((s) => !s)}
        >
          {show ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
    </div>
  );
}

export default function ChangePasswordModal({ open, onClose }) {
  const { t, toast } = useStore();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast(t("auth.pwChanged"));
      setCurrent("");
      setNext("");
      onClose();
    } catch (err) {
      const d = err.response?.data?.detail;
      if (typeof d === "string" && d.includes("Current password")) setError(t("auth.pwMismatch"));
      else setError(typeof d === "string" ? d : t("toast.orderFail"));
    }
    setBusy(false);
  };

  return (
    <div className="modal show" data-testid="change-password-modal">
      <div className="modal-card auth-card" data-lenis-prevent>
        <div className="modal-head">
          <div>
            <p className="section-title-small">PAMAK ACCOUNT</p>
            <h2>{t("auth.changePassword")}</h2>
          </div>
          <button className="close-btn" aria-label="Close" data-testid="change-password-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <form onSubmit={submit} className="auth-form">
          <EyeField
            testid="current-password-input"
            eyeTestid="current-password-eye"
            label={t("auth.currentPassword")}
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
          <EyeField
            testid="new-password-input"
            eyeTestid="new-password-eye"
            label={t("auth.newPassword")}
            value={next}
            onChange={(e) => setNext(e.target.value)}
          />
          <p className="error-text" data-testid="change-password-error">{error}</p>
          <button className="checkout-btn" type="submit" data-testid="change-password-submit" disabled={busy}>
            {t("auth.changePassword")}
          </button>
        </form>
      </div>
    </div>
  );
}
